export class OpenClientInvitationModel {
  id: number;
  email: string;
  invitationCounter: number;
  lastInvitationSentAt: string;
}

export class ClientReferrersModel {
  userId: string;
  firstName: string;
  lastName: string;
  referredUsers: ReferredUserModel[];
  collapsed?: boolean = false;
}

export class ReferredUserModel {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  referredAt: string;
}

export enum ClientInvitationFilterStatus {
  ALL = 'ALL',
  OPEN = 'OPEN',
  REGISTERED = 'REGISTERED',
}

export class ClientInvitationListItemModel {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  invitationCounter: number;
  lastInvitationSentAt: string;
  invitedClientUserId: string | null;
  registered: boolean;
  inviteeUserId: string;
}

// If a shared generic page response model already exists elsewhere in the
// codebase, drop this and import that one instead — this is a stand-in.
export interface ClientInvitationResponseModel {
  data: ClientInvitationListItemModel[];
  total: number;
  totalPages: number;
  page: number;
  pageSize: number;
}
